import React, { memo } from "react";

const Details = memo(function Details({ user, totalQuestions, time }) {
  return (
    <div className="col-lg-12 mock-resource-text">
      <h4 className="mt-0">Welcome {user.first_name} {user.last_name}</h4>
      <div className="col-12 d-none d-md-block">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Section</th>
            <th>No. of Question</th>
            <th>Time Allowed</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Listening</td>
            <td>{totalQuestions}</td>
            <td>{time} minutes</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="col-12 d-block d-md-none">
      <div className="border rounded p-3">
        <p className="mb-2">
          <strong>Section:</strong> Listening
        </p>
        <p className="mb-2">
          <strong>No. of Question:</strong> {totalQuestions}
        </p>
        <p className="mb-0">
          <strong>Time Allowed:</strong> {time} minutes
        </p>
      </div>
    </div>
    </div>
  );
});

export default Details;
